import { CellProps } from 'react-table'
import { formatDateToPtBr } from '../../../../../../../_metronic/helpers'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { FeriadoList } from '../../../core/_models'
import { TIPO_FERIADO_LABELS } from '../../../core/escalaHelpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { FeriadosActionsCell } from './FeriadosActionsCell'

const feriadosColumns: ReadonlyArray<TableColumn<FeriadoList>> = [
  // Nome e tipo do feriado numa célula só (tipo como apoio); os dois seguem ordenáveis.
  sortableColumn<FeriadoList>({
    id: 'nome',
    useQueryRequest,
    fields: [
      { field: 'nome', label: 'Feriado' },
      { field: 'tipo', label: 'Tipo' },
    ],
    Cell: ({ row }: CellProps<FeriadoList>) => (
      <StackedCell
        primary={row.original.nome}
        secondary={TIPO_FERIADO_LABELS[row.original.tipo] ?? row.original.tipo}
      />
    ),
  }),
  sortableColumn<FeriadoList>({
    id: 'data',
    cellWidth: '140px',
    useQueryRequest,
    fields: [{ field: 'data', label: 'Data' }],
    // `data` é `LocalDate` puro: `formatDateToPtBr` faz split de string e não
    // constrói `Date` (que exibiria o dia anterior no fuso de São Paulo).
    Cell: ({ row }: CellProps<FeriadoList>) => (
      <StackedCell
        tabular
        primary={row.original.dataFormatada || formatDateToPtBr(row.original.data)}
      />
    ),
  }),
  sortableColumn<FeriadoList>({
    id: 'anual',
    cellWidth: '180px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'anual', label: 'Repete todo ano' }],
    Cell: ({ row }: CellProps<FeriadoList>) => (
      <span className={`badge ${row.original.anual ? 'badge-light-primary' : 'badge-secondary'}`}>
        {row.original.anual ? 'Sim' : 'Não'}
      </span>
    ),
  }),
  {
    Header: () => <PlainHeader>Ações</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<FeriadoList>) => <FeriadosActionsCell feriado={row.original} />,
  },
]

export { feriadosColumns }
